import { render, staticRenderFns } from "./ShowBasicPoll.vue?vue&type=template&id=627cb52e&scoped=true&"
import script from "./ShowBasicPoll.vue?vue&type=script&lang=ts&"
export * from "./ShowBasicPoll.vue?vue&type=script&lang=ts&"
import style0 from "./ShowBasicPoll.vue?vue&type=style&index=0&id=627cb52e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cb52e",
  null
  
)

export default component.exports